import { LEGAL, ENTITY, SUPPORT } from "../legal/docs";

// The footer on every screen: who runs the service, how to reach support, the status page and the legal pages.
export function Footer({ kind = "app" }: { kind?: "app" | "public" }) {
  return (
    <footer className={`app-foot${kind === "public" ? " public" : ""}`}>
      <div className="who">
        <span><b>Altekore Books</b> is provided by {ENTITY}. Your data is stored in India.</span>
        <span>Write to <a href={`mailto:${SUPPORT}`}>{SUPPORT}</a> for help.</span>
        <span>© {new Date().getFullYear()} {ENTITY}</span>
      </div>
      <nav aria-label="Support and legal">
        {/* each opens in its own tab, so the page you're on stays where it is */}
        <a href="/status" target="_blank" rel="noopener">System status</a>
        {LEGAL.map((d) => <a key={d.slug} href={`/legal/${d.slug}`} target="_blank" rel="noopener">{d.short}</a>)}
      </nav>
    </footer>
  );
}
